<template>
  <div
    :class="['lock-toggle', { unlocked: !value }]"
    @click="onClick"
  >
    <icon :name="state" />
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
      },
    },
    methods: {
      onClick() {
        this.$emit('input', !this.value);
      },
    },
    computed: {
      state() {
        return 'sync';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../variables';

  .lock-toggle {
    cursor: pointer;
  }
  .unlocked {
    color: $gray-400;
  }
</style>
